// import Vue from 'vue'
import { Model } from '..'
import { PagedCollection } from '..'
import Enhancer from '../Enhancer'
import store from '@/modules/store'
import { Query } from '@/modules/plugins/query'
import isEmpty from 'lodash.isempty'

class Restaurant extends Model {
    constructor(json, ...args) {
        super(...args)
        this.apiBase = 'restaurants'
        this._model = json
        return new Proxy(this, Enhancer)
    }

    get tags() {
        return this._model?.tags || []
    }

    get root() {
        return {
            link: this.link,
            id: this.id,
            slug: this._model?.slug,
            country: this._model?.country,
            name: this._model?.name,
        }
    }

    async fetchRestaurant(slug, params = {}) {
        let time = store.getters['order/time']
        let address = store.getters['order/address']
        let asap = store.getters['order/asap']
        try {
            const res = await super.fetch(slug, {
                ...{
                    ...Query.getLocationParams(address),
                    ...Query.getDeliveryTimeParams(time ? (asap ? undefined : time) : undefined),
                },
                ...params,
            })
            store.dispatch('getDeliveryPeriod', {
                restaurantId: res.id,
                allowanceId: store.getters['allowance']?.id,
            })
            return Promise.resolve(res)
        } catch (e) {
            return Promise.reject(e)
        }
    }
    favourite() {
        return new Promise((resolve, reject) => {
            try {
                this.save('favorite', null)
                    .then((res) => {
                        this._model.is_favorite = res.is_favorite
                        return resolve(res)
                    })
                    .catch((e) => {
                        return reject(e)
                    })
            } catch (e) {
                return reject(e)
            }
        })
    }
}

class Restaurants extends PagedCollection {
    constructor(...args) {
        super(...args)
        this.apiRoot = 'frontend-api'
        this.apiVersion = 'public'
        this.apiBase = 'restaurant/search'
        this._featured = []
        this._popular = []
        this._reload = false
        this._delay = false
        this._timeout = null
        this._showAll = true
        this.tagCounts = []
    }

    push(item, type) {
        super.push(new Restaurant(item), type)
    }

    get reload() {
        return this._reload
    }

    get delay() {
        return this._delay
    }

    get featured() {
        return this._featured
    }

    set featured(featured) {
        this._featured = []
        featured.forEach((item) => {
            this.push(item, '_featured')
        })
    }

    get popular() {
        return this._popular
    }

    set popular(popular) {
        this._popular = []
        popular.forEach((item) => {
            this.push(item, '_popular')
        })
    }

    async fetchRestaurants(params = {}, extraOptions) {
        this._reload = true
        if (this._timeout) clearTimeout(this._timeout)
        this._timeout = setTimeout(() => {
            this._delay = true
        }, 1000)
        const canteen = store.getters['active/canteen']
        params = Object.assign(
            {
                page: 1,
                limit: 20,
                tag_name: undefined,
                tag_names: undefined,
                bannerId: undefined,
                quick_search: params.search,
                ...Query.getCanteenParams(canteen),
                ...Query.getLocationParams(store.getters['order/address']),
                ...Query.getDeliveryTimeParams(
                    store.getters['order/asap'] ? undefined : store.getters['order/time']
                ),
            },
            params
        )
        delete params.search
        if (!isEmpty(canteen)) params = Query.removeUnnecessaryQuery(params)
        try {
            const result = await this.fetch(params, false, extraOptions, false)
            this.featured = result.featured
            this.popular = result.popular
            this.tagCounts = result.tag_counts
            return Promise.resolve(result)
        } catch (e) {
            return Promise.reject(e)
        } finally {
            this._reload = false
            this._delay = false
            if (this._timeout) {
                clearTimeout(this._timeout)
                this._timeout = null
            }
        }
    }

    async locationInRange(latitude, longitude) {
        if (!latitude || !longitude) return Promise.reject('Missing coordinates!')
        try {
            const result = await this.fetch(
                {
                    user_lat: latitude,
                    user_lon: longitude,
                    limit: 1,
                    featured_count: 1,
                    popular_count: 1,
                },
                false,
                undefined,
                false
            )
            return Promise.resolve(result.total > 0)
        } catch (e) {
            return Promise.reject(e)
        }
    }
}

export { Restaurant, Restaurants }
